common.View.create('project::website.modules.projects.Index', {

    markers: [],

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initMap();

        // this.element.find('.filterOption').on('click', (event) => {
        //     this.initMap();
        // });

        let observer = new MutationObserver(() => {
            this.removeMarkers();
            this.setupMap();
        });
        observer.observe(this.element.find('.locations').get(0), {
            attributes: true,
            attributeFilter: ['data-locations']
        });
    },

    initMap()
    {
        let apiKey = this.element.find('.apiKey').text();

        // Check when script is done loading
        $.getScript('https://maps.googleapis.com/maps/api/js?key='+ apiKey +'&libraries=places&callback=project.website.modules.projects.Index', () => {
            this.setupMap(true);
        });
    },

    removeMarkers()
    {
        // Loop through markers and set map to null for each
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }

        // Reset the markers array
        this.markers = [];
    },

    setupMap(fitBounds = false)
    {
        // Get google maps api key
        let locations = JSON.parse(this.element.find('.locations').attr('data-locations')),
            map,
            bounds = new google.maps.LatLngBounds(),
            infowindow = new google.maps.InfoWindow({ minHeight: 250, maxWidth: 320 });

        // Init map
        map = new google.maps.Map(this.element.find("#map").get(0), {
            center: new google.maps.LatLng(52.2920229, 5.1867626),
            zoom: 7,
        });

        // Create markers.
        for (let i = 0; i < locations.length; i++) {
            // Create marker with position and icon
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
                icon: '/img/website/location.svg',
                map: map,
            });

            // Add marker to bounds to include each marker's position
            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    infowindow.setContent('<img alt="'+ locations[i]['image']['name'] +'" src="'+ locations[i]['image']['src']+'" srcset="'+ locations[i]['image']['srcset']+'" class="w-full" loading="lazy" />' +
                        '<div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-x-6 gap-y-4 p-2">' +
                            '<div>' +
                                '<div class="font-medium text-xs">'+ locations[i]['city'] +'</div>' +
                                '<div class="font-semibold text-lg">' + locations[i]['title'] + '</div>' +
                            '</div>' +
                            '<a class="bg-black text-white px-4 py-2 rounded-2xl hover:opacity-75" href="' + locations[i]['url'] + '">Bekijken' + '</a>' +
                        '</div>'
                    );
                    infowindow.open(map, marker);
                };
            })(marker, i));

            this.markers.push(marker);
        }

        // Now fit the map to the newly inclusive bounds
        if( fitBounds ) {
            map.fitBounds(bounds);
        }

        //(optional) restore the zoom level after the map is done scaling
        // var listener = google.maps.event.addListener(map, "idle", function () {
        //     map.setZoom(8);
        //     google.maps.event.removeListener(listener);
        // });
    }

});
